export default __webpack_public_path__ + "static/media/gallery-wip-pommel_00.044c9211.jpg";